import { Table } from "@/features/Table";
import { type S1Metadata, s1_metadata_columns } from "./columns";
import { type FilterS1MetadataSchema, FilterS1Metadata } from "./filter";
import { useLocation } from "react-router";

const client = "s1-quantilia";
const table_name = "s1_metadata";

export const S1MetadataTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<S1Metadata, FilterS1MetadataSchema>
      label="S1 Metadata"
      client={client}
      table_name={table_name}
      columns={s1_metadata_columns}
      filter={<FilterS1Metadata />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
